import React from 'react';

import styled from 'styled-components';

import { desktop, mobile, tabletDevice } from '../../styles';

function getBreakpointStyles({ breakpoints }) {
  return breakpoints.map(breakpoint => {
    const padding = breakpoint.padding || 0;
    const paddingMinusGap = Math.max(0, padding - breakpoint.gap);

    return breakpoint.css`
      margin-left: -${breakpoint.gap}px;
      padding-left: ${breakpoint.padding || 0}px;
      padding-right: ${breakpoint.padding || 0}px;

      > *,
      > [data-span="1"] {
        width: ${breakpoint.columnWidth};
        margin-left: ${breakpoint.gap}px;
        ${props =>
          props.theme.context.bca &&
          mobile`
            margin-left: 0;
          `};
        ${props =>
          props.theme.context.bca &&
          desktop`
            /* Override grid, on desktop always use 3 cols for product cells. */
            width: calc(${(1 / 3) * 100}% - ${breakpoint.gap}px);
          `};
        ${props =>
          props.theme.context.bca &&
          tabletDevice`
            width: calc(${(1 / 4) * 100}% - ${breakpoint.gap}px);
          `};
      }

      > [data-span="2"] {
        width: calc(${200 / breakpoint.columns}% - ${breakpoint.gap}px);
      }

      ${props =>
        props.theme.context.bca &&
        desktop`
          > [data-span="2"] {
            max-width: 482px;
          }
        `};

      ${props =>
        props.theme.context.bca &&
        tabletDevice`
          > [data-span="2"] {
            max-width: unset;
          }
        `};

      ${props =>
        props.theme.context.bca &&
        mobile`
          > [data-span="2"] {
            width: calc(${200 / breakpoint.columns}%);
          }
        `};

      > [data-span="fullWidth"] {
        width: calc(100% + ${paddingMinusGap}px + ${padding}px);
        margin-left: -${paddingMinusGap}px;
        ${props =>
          props.theme.context.bca &&
          desktop`
            margin-top: 40px !important;
            margin-bottom: 56px !important;
          `};
        ${props =>
          props.theme.context.bca &&
          mobile`
            margin-top: 40px !important;
            margin-bottom: 40px !important;
          `};
      }
    `;
  });
}

const Wrapper = styled.div`
  overflow: auto;

  > * {
    float: left;
  }

  > [data-align='right'] {
    float: right;
  }

  ${props =>
    props.theme.context.bca &&
    mobile`
      > div {
        padding-right: 16px;
      }
    `};

  ${getBreakpointStyles};
`;

export default function Grid({ breakpoints, children, ...rest }) {
  return (
    <Wrapper
      data-qa-automation="gridSetsPage"
      breakpoints={breakpoints}
      {...rest}
    >
      {children}
    </Wrapper>
  );
}
